import {OptionWithValues, useProductOptions} from '@shopify/hydrogen';
// import { useEffect } from 'react';
// import type {SanityCustomProductOption} from '../../../types';
// import ProductOptionsColor from './ProductOptionsColor.client';
// import ProductOptionsSize from './ProductOptionsSize.client';
import ProductOptionsDefault from './ProductOptionsDefault.client';

// type Props = {
//   customProductOptions?: SanityCustomProductOption[];
// };

export default function ProductOptions() {
  const {options, variants} = useProductOptions();

  const createEditedOptions = (options: any, variants: any) => {
    const editedOptions = options.map((option: any) => {
      const values = option.values.map((value: any, index: any) => {
        return { name: value, availableForSale: variants[index].availableForSale };
      });
      return { ...option, values };
    });
    return editedOptions;
  }
  const updateOptions = createEditedOptions(options, variants);

  return (
    <div className="text-small pr-10 mt-beforeFooter sm:mt-0">
      {(updateOptions as any[])?.map(({name, values}) =>
        <ProductOptionsDefault
          key={name}
          name={name}
          values={values}
        />
      )}
    </div>
  )
}

// Check if current product has a valid custom option type.
// If so, render a custom option component.
// const customProductOption = customProductOptions?.find(
//   (option) => option.title === name,
// );
// switch (customProductOption?._type) {
//   case 'customProductOption.color':
//     return (
//       <ProductOptionsColor
//         customProductOption={customProductOption}
//         key={name}
//         name={name}
//         values={values}
//       />
//     );
//   case 'customProductOption.size':
//     return (
//       <ProductOptionsSize
//         customProductOption={customProductOption}
//         key={name}
//         name={name}
//         values={values}
//       />
//     );
//   default:
// return (
//   <ProductOptionsDefault key={name} name={name} values={values} />
// )